import { Breadcrumb, Button, Checkbox, Col, Drawer, Empty, Flex, Form, Input, Popconfirm, Row, Select, Table, Tag, Tooltip, Typography, notification, theme } from 'antd';
import { HomeOutlined, DeleteOutlined, EyeOutlined, EditOutlined, LockOutlined, UnlockOutlined, FilterOutlined, WarningOutlined, KeyOutlined } from '@ant-design/icons';
import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import MasterDataAPI from '../../restAPI/MasterDataAPI';
import UserProfileAPI from '../../restAPI/UserProfileAPI';
import { useNavigate } from 'react-router-dom';
import FilterComponent from '../../utils/FilterComponent';
import dayjs from 'dayjs';
import CommonSkeletonLoader from '../../helperComponents/CommonSkeleton';
import { COLOR } from '../../theme/constant';

const { Search } = Input;
const { Text, Link } = Typography;

export default function User() {
    const navigate = useNavigate();
    const { companyId, token, userCompany, role } = useSelector(state => state.auth);
    const [form] = Form.useForm();
    const formValues = Form.useWatch([], form);

    const [userId, setUserId] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [initialUserData, setInitialUserData] = useState({ 
        name: "", 
        email: "", 
        personalNumber: "", 
        address: "", 
        roleId: null, 
        branchId: null, 
        departmentId: null, 
        designation: "" 
    });
    const [actionState, setActionState] = useState('add')
    const [searchInputValue, setSearchInputValue] = useState("");
    const [viewData, setViewData] = useState({
        email: "",
        name: "",
        personalNumber: "",
        address: "",
        roleId: null,
        branchId: null,
        departmentId: null,
        designation: "",
        status: null,
    });
    const [userData, setUserData] = useState([]);
    const [roleList, setRoleList] = useState([]);
    const [branchList, setBranchList] = useState([]);
    const [tempUserData, setTempUserData] = useState([]);
    const [roleListData, setRoleListData] = useState([]);
    const [filterValues, setFilterValues] = useState([]);
    const [departmentList, setDepartmentList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [openFilter, setOpenFilter] = useState(false);
    const [showPopconfirm, setShowPopconfirm] = useState(false);
    const [dropDownDisable, setDropDownDisable] = useState(false);
    const [cancelButtonDisabled, setCancelButtonDisabled] = useState(false);
    const [isUserListLoading, setIsUserListLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const [btnPermission, setBtnPermission] = useState({
        "add": false,
        "edit": false,
        "delete": false,
        "view": false,
        "activeInactive": false
    });

    const [open, setOpen] = useState(false);
    const [open2, setOpen2] = useState(false); // New state for view drawer

    const showFilterDrawer = () => {
        setOpenFilter(true);
    };
    const onCloseFilter = () => {
        setOpenFilter(false);
    };

    const getNameRules = useCallback(() => [
        {
            required: true,
            message: 'Name is required',
        },
        {
            max: 50,
            message: 'Name must be less than 50 characters',
        },
        {
            validator: (_, value) => {
                if (value && value.trim().length === 0) {
                    return Promise.reject(new Error('Name is not valid.'));
                }
                return Promise.resolve();
            },
        },
    ], []);

    const getEmailRules = useCallback(() => [
        {
            required: true,
            message: 'Email is required',
        },
        {
            type: 'email',
            message: 'Invalid email address',
        },
    ], []);

    const getUserMobileRules = useCallback(() => [
        {
            validator: (_, value) => {
                if (!value) return Promise.resolve();
                if (!/^\d+$/.test(value)) {
                    return Promise.reject(new Error('Mobile number must contain only numbers.'));
                }
                if (value.length < 9 || value.length > 15) {
                    return Promise.reject(new Error('Mobile number must be between 9 and 15 digits.'));
                }
                return Promise.resolve();
            },
        },
    ], []);

    const getAddressRules = useCallback(() => [
        {
            max: 255,
            message: 'Address must be less than 255 characters',
        },
    ], []);

    const getUserRoleRules = useCallback(() => [
        {
            required: true,
            message: 'User role is required',
        },
    ], []);

    const getBranchRules = useCallback(() => [
        {
            required: true,
            message: 'Branch is required',
        },
    ], []);

    const getDesignationRules = useCallback(() => [
        {
            max: 50,
            message: 'Designation must be less than 50 characters',
        },
        {
            validator: (_, value) => {
                if (value && value.trim().length === 0) {
                    return Promise.reject(new Error('Designation is not valid.'));
                }
                return Promise.resolve();
            },
        },
    ], []);

    const isFormModified = useCallback(() => {
        if (actionState !== 'edit') return true;
        
        if (!formValues) return false;
        
        const currentValues = form.getFieldsValue();
        const nameChanged = (currentValues.name || '').trim() !== (initialUserData.name || '').trim();
        const emailChanged = (currentValues.email || '').trim() !== (initialUserData.email || '').trim();
        const personalNumberChanged = (currentValues.personalNumber || '') !== (initialUserData.personalNumber || '');
        const addressChanged = (currentValues.address || '').trim() !== (initialUserData.address || '').trim();
        const roleIdChanged = currentValues.roleId !== initialUserData.roleId;
        const branchIdChanged = currentValues.branchId !== initialUserData.branchId;
        const departmentIdChanged = currentValues.departmentId !== initialUserData.departmentId;
        const designationChanged = (currentValues.designation || '').trim() !== (initialUserData.designation || '').trim();
        
        return nameChanged || emailChanged || personalNumberChanged || addressChanged || 
               roleIdChanged || branchIdChanged || departmentIdChanged || designationChanged;
    }, [actionState, formValues, initialUserData, form]);

    const showDrawer = () => {
        form.resetFields();
        setInitialUserData({ 
            name: "", 
            email: "", 
            personalNumber: "", 
            address: "", 
            roleId: null, 
            branchId: null, 
            departmentId: null, 
            designation: "" 
        });
        setActionState('add');
        setOpen(true);
    };

    const showDrawer2 = () => {
        setOpen2(true);
    };

    const onClose = () => {
        form.resetFields();
        setInitialUserData({ 
            name: "", 
            email: "", 
            personalNumber: "", 
            address: "", 
            roleId: null, 
            branchId: null, 
            departmentId: null, 
            designation: "" 
        });
        getUserData(false);
        setOpen(false);
        setDropDownDisable(false);
        setShowPopconfirm(false);
        setUserId("");
        setTimeout(() => {
            setActionState('add')
        }, 200)
    };

    const onClose2 = () => {
        setOpen2(false);
        setViewData({
            email: "",
            name: "",
            personalNumber: "",
            address: "",
            roleId: null,
            branchId: null,
            departmentId: null,
            designation: "",
            status: null,
        });
    };

    const {
        token: { colorBgContainer, borderRadiusLG, colorWarning },
    } = theme.useToken();

    const [api, contextHolder] = notification.useNotification();


    const openNotificationWithIcon = (type, message, description, placement) => {
        api[type]({
            message: message,
            description: description,
            placement
        });
    };

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Created Date',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (text) => {
                if (!text) return '';
                try {
                    const date = new Date(text);
                    return date.toISOString().split('T')[0];
                } catch (e) {
                    console.error('Invalid date:', text);
                    return 'Invalid date';
                }
            }
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Role',
            dataIndex: 'roleName',
            key: 'roleName',
        },
        {
            title: 'Branch',
            dataIndex: 'branchName',
            key: 'branchName',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            fixed: 'right',
            render: (_, record) => (
                record.status ? (<Tag color='purple' style={{ width: 90, textAlign: 'center' }}>Active</Tag>) : (<Tag color='warning' style={{ width: 90, textAlign: 'center' }}>Inactive</Tag>)
            ),
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            align: 'center',
            fixed: 'right',
            render: (_, record) => (
                <Flex gap="small" justify="center" align="center" vertical>
                    <Flex gap="middle" wrap="wrap">
                        {btnPermission.edit &&
                            <Tooltip title="Edit User" placement="top">
                                <Button type="primary" disabled={!record.status} icon={<EditOutlined />} size='small' onClick={() => editHandler(record)} />
                            </Tooltip>
                        }
                        {btnPermission.view &&
                            <Tooltip title="View User" placement="top">
                                <Button icon={<EyeOutlined />} size='small' onClick={() => viewHandler(record)} />
                            </Tooltip>
                        }
                        {btnPermission.edit &&
                            <Tooltip title="Unlock User" placement="top">
                                <Popconfirm
                                    title="Do you want to unlock this user?"
                                    onConfirm={() => unlockHandler(record)}
                                    onCancel={() => openNotificationWithIcon('error', 'Abort', `Unlock cancelled`, 'bottomLeft')}
                                    okText="Yes"
                                    cancelText="No"
                                >
                                    <Button
                                        disabled={!record.status || !record?.isUserLock}
                                        icon={<KeyOutlined />}
                                        size="small"
                                        type={record?.isUserLock || !record.status ? "primary" : "primary"}
                                        style={{
                                            backgroundColor: record?.isUserLock && record.status ? COLOR.wisteria500 : undefined
                                        }}
                                    />
                                </Popconfirm>
                            </Tooltip>
                        }
                        {
                            btnPermission.activeInactive && (
                                <Tooltip title="Active/Inactive User" placement="top">
                                    <Popconfirm
                                        title={record.status ? "Do you want to Inactivate the user?" : "Do you want to reactivate the user?"}
                                        onConfirm={() => editStatusHandler(record)}
                                        onCancel={() => openNotificationWithIcon('error', 'Abort', `Status update cancelled`, 'bottomLeft')}
                                        okText="Yes"
                                        cancelText="No"
                                    >
                                        <Button disabled={record?.roleName === "Company Admin"} icon={record.status ? <LockOutlined /> : <UnlockOutlined />} size='small' />
                                    </Popconfirm>
                                </Tooltip>
                            )
                        }
                        {btnPermission.edit &&
                            <Tooltip title="Reset Password" placement="top">
                                <Popconfirm
                                    title="Do you want to reset the password of this user?"
                                    onConfirm={() => resetHandler(record)}
                                    onCancel={() => openNotificationWithIcon('error', 'Abort', `Reset cancelled`, 'bottomLeft')}
                                    okText="Yes"
                                    cancelText="No"
                                >
                                    <Button
                                        disabled={!record.status}
                                        icon={<WarningOutlined />}
                                        size="small"
                                        type={record?.isUserLock || !record.status ? "primary" : "primary"}
                                        style={{
                                            backgroundColor: colorWarning
                                        }}
                                    />
                                    {/*<Button type="primary" disabled={!record.status || record?.isUserLock} icon={<WarningOutlined />} size='small' style={{ backgroundColor: colorWarning }} />*/}
                                </Popconfirm>
                            </Tooltip>
                        }
                        {btnPermission.delete && (
                            <Tooltip title="Delete User" placement="top">
                                <Popconfirm
                                    title="Do you want to delete this user?"
                                    onConfirm={() => deleteHandler(record)}
                                    onCancel={() => openNotificationWithIcon('error', 'Abort', `Delete cancelled`, 'bottomLeft')}
                                    okText="Yes"
                                    cancelText="No"
                                >
                                    <Button disabled={record?.roleName === "Company Admin" ? true : record.status} danger type="primary" icon={<DeleteOutlined />} size='small' />
                                </Popconfirm>
                            </Tooltip>
                        )}
                    </Flex>
                </Flex>
            ),
        },
    ];

    const getCompanyRole = async () => {
        await MasterDataAPI.getRoleDataByCompanyIdForUserDropdown(companyId, token).then((res) => {
            const activeRoles = res?.data ? res?.data.filter(role => role.status).map(role => {
                return { label: role.name, value: role.id };
            }) : [];
            setRoleListData(activeRoles);
        }).catch(err => { });
    }

    const getCompanyDepartment = async () => {
        await MasterDataAPI.getDepartmentsDataByCompanyId(companyId, token).then((res) => {
            const activeDepartments = res?.data ? res?.data.data.filter(department => department.status).map(department => {
                return { label: department.name, value: department.id };
            }) : [];
            setDepartmentList(activeDepartments);
        }).catch(err => { });
    }

    const getCompanyBranch = async () => {
        await MasterDataAPI.getBranchDataByCompanyId(companyId, token).then((res) => {
            const activeBranches = res?.data ? res?.data.filter(branch => branch.status).map(branch => {
                return { label: branch.name, value: branch.id };
            }) : [];
            setBranchList(activeBranches);
        }).catch(err => { });
    }

    useEffect(() => {
        setIsUserListLoading(true);
        getUserData();
    }, [companyId]);

    useEffect(() => {
        if (userCompany?.companyData) {
            const companyData = userCompany.companyData.find(company => company.companyId === companyId);
            if (companyData && companyData.companyName) {
                setCompanyName(companyData.companyName);
            }
        }
        getCompanyRole();
        getCompanyDepartment();
        getCompanyBranch();
    }, [companyId]);

    const applySearchAndFilters = (data, searchText, filters) => {
        return data.filter((user) => {
            const matchesSearch = searchText ? 
                (user?.name || '').toLowerCase().includes(searchText.toLowerCase()) 
                || (user?.email || '').toLowerCase().includes(searchText.toLowerCase()) 
                || (user?.roleName || '').toLowerCase().includes(searchText.toLowerCase()) 
                : true
            
            const matchesFilters = filters.length > 0 ?
                filters.every(({ key, value }) => {
                    if (!value) return false;
                    const itemValue = (user[key]?.toString() || '').toLowerCase();
                    return itemValue.startsWith(value.toLowerCase());
                })
                : true

            return matchesSearch && matchesFilters
        })
    }

    const getUserData = async (isFirstTime = true) => {
        try {
            const res = await MasterDataAPI.getUsersDataByCompanyId(companyId, token);
            if (res?.data) {
                const data = res.data.map((value) => ({
                    name: value?.name,
                    address: value?.address || "",
                    designation: value?.designation || "",
                    email: value?.email,
                    lastPasswordUpdateDate: value?.lastPasswordUpdateDate,
                    passwordExpireDate: value?.passwordExpireDate,
                    isUserLock: value?.isUserLock,
                    personalNumber: value?.personalNumber || null,
                    roleId: value?.roles[0]?.id,
                    roleName: value?.roles[0]?.name,
                    departmentId: value?.department?.id || null,
                    departmentName: value?.department?.name || null,
                    branchId: value?.branch?.id || null,
                    branchName: value?.branch?.name || null,
                    status: value?.status,
                    _id: value?.id,
                    userId: value?.userId || "",
                    createdAt: value?.createdAt ? dayjs(value?.createdAt).format('YYYY-MM-DD') : "" || ""
                }));
                if (!isFirstTime) {
                    const updatedUsersList = data;
                    setUserData(data)
                    const updatedTempList = applySearchAndFilters(updatedUsersList, searchInputValue, filterValues);
                    setTempUserData(updatedTempList);
                }

                if (isFirstTime) {
                    setUserData(data)
                    setTempUserData(data)
                    setIsUserListLoading(false)
                }
            }
        } catch (err) {
            setIsUserListLoading(false)
        } finally {
            setIsUserListLoading(false)
        }
    }

    const editStatusHandler = async (records) => {
        const formData = {
            status: !records.status,
        }
        await MasterDataAPI.updateStatusUser(records._id, formData, companyId, token).then((res) => {
            openNotificationWithIcon('success', 'Successful', `${res.message}`, 'bottomLeft');
            // setSearchInputValue('');
            // setFilterValues([]);
            getUserData(false);
        }).catch((err) => {
            if (err.response) {
                openNotificationWithIcon('error', 'User status change failed', `${err.response.data.message}`, 'bottomLeft');
            } else {
                openNotificationWithIcon('error', 'User status change failed', `${err.message}`, 'bottomLeft');
            }
        })
    }

    const deleteHandler = async (records) => {
        await MasterDataAPI.deleteUser(records._id, companyId, token).then((res) => {
            openNotificationWithIcon('success', 'Successful', `${res.message}`, 'bottomLeft');
            const updatedUserList = tempUserData.filter((user) => user._id !== records._id)
            // setTempUserData(updatedUserList);
            // setSearchInputValue('');
            // setFilterValues([]);
            getUserData(false);
        }).catch((err) => {
            if (err.response) {
                openNotificationWithIcon('error', 'User deletion failed', `${err.response.data.message}`, 'bottomLeft');
            } else {
                openNotificationWithIcon('error', 'User deletion failed', `${err.message}`, 'bottomLeft');
            }
        })
    }
    
    const unlockHandler = async (records) => {

        const formData = {
            isUserLock: !records.isUserLock,
        }

        await MasterDataAPI.unlockUser(records.userId, formData, companyId, token).then((res) => {
            openNotificationWithIcon('success', 'Successful', `${res.message}`, 'bottomLeft');
            //update tempUserData list to reflect the unlocked user
            const updatedUserList = tempUserData.map((user) => {
                if (user.userId === records.userId) {
                    return { ...user, isUserLock: false }; // Update the user to reflect the unlocked status
                }
                return user;
            }
            );
            setTempUserData(updatedUserList);
        }).catch((err) => {
            if (err.response) {
                openNotificationWithIcon('error', 'User unlock failed', `${err.response.data.message}`, 'bottomLeft');
            } else {
                openNotificationWithIcon('error', 'User unlock failed', `${err.message}`, 'bottomLeft');
            }
        })
    }

    const resetHandler = async (records) => {
        await UserProfileAPI.resetPassword(null, records._id, companyId, token).then((res) => {
            openNotificationWithIcon('success', 'Successful', `${res.data.message}`, 'bottomLeft');
        }).catch((err) => {
            if (err.response) {
                openNotificationWithIcon('error', 'User reset failed', `${err.response.data.message}`, 'bottomLeft');
            } else {
                openNotificationWithIcon('error', 'User reset failed', `${err.message}`, 'bottomLeft');
            }
        })
    }

    const viewHandler = (records) => {
        setViewData({
            email: records.email,
            name: records.name,
            personalNumber: records.personalNumber,
            address: records.address,
            roleId: records.roleId,
            branchId: records.branchId,
            departmentId: records.departmentId,
            designation: records.designation,
            status: records.status,
        });
        if (records.roleName === "Company Admin") {
            setRoleList(roleListData)
            setDropDownDisable(true);
        } else {
            const activeDepartments = roleListData.filter(value => value.label !== "Company Admin")
            setRoleList(activeDepartments)
            setDropDownDisable(false);
        }
        setUserId(records._id)
        showDrawer2();
    }

    const editHandler = (records) => {
        const initialValues = {
            email: records.email,
            name: records.name,
            personalNumber: records.personalNumber || "",
            address: records.address || "",
            roleId: records.roleId,
            branchId: records.branchId,
            departmentId: records.departmentId,
            designation: records.designation || "",
        };
        setInitialUserData(initialValues);
        form.setFieldsValue(initialValues);
        if (records.roleName === "Company Admin") {
            setRoleList(roleListData)
            setDropDownDisable(true);
        } else {
            const activeDepartments = roleListData.filter(value => value.label !== "Company Admin")
            setRoleList(activeDepartments)
            setDropDownDisable(false);
        }
        setUserId(records._id)
        setActionState("edit")
        setOpen(true);
    }

    const validateBeforeSubmit = async () => {
        try {
            await form.validateFields();
            return true;
        } catch (errorInfo) {
            return false;
        }
    };

    const handleSubmit = async () => {
        const validation = await validateBeforeSubmit();
        if (!validation) {
            return;
        }

        setLoading(true);
        const formValues = form.getFieldsValue();
        
        if (actionState === "add") {
            const trimmedPayload = {
                email: (formValues.email || "").trim().toLowerCase(),
                name: (formValues.name || "").trim(),
                personalNumber: formValues.personalNumber || null,
                address: (formValues.address || "").trim() || null,
                designation: (formValues.designation || "").trim() || null,
                roleId: [formValues.roleId],
                departmentId: formValues.departmentId || null,
                branchId: formValues.branchId || null,
            };
            try {
                const { message } = await MasterDataAPI.createUser(trimmedPayload, companyId, token);
                openNotificationWithIcon('success', 'Successful', `${message}`, 'bottomLeft');
                onClose();
            } catch (error) {
                if (error.response) {
                    openNotificationWithIcon('error', 'User creation failed', `${error.response.data.message}`, 'bottomLeft');
                } else {
                    openNotificationWithIcon('error', 'User creation failed', `${error.message}`, 'bottomLeft');
                }
            } finally {
                setShowPopconfirm(false);
                setLoading(false);
            }
        }

        if (actionState === "edit") {
            const trimmedPayload = {
                name: (formValues.name || "").trim(),
                personalNumber: formValues.personalNumber || null,
                address: (formValues.address || "").trim() || null,
                designation: (formValues.designation || "").trim() || null,
                roleId: [formValues.roleId],
                departmentId: formValues.departmentId || null,
                branchId: formValues.branchId || null,
            };
            try {
                const { message } = await MasterDataAPI.updateUser(userId, trimmedPayload, companyId, token);
                openNotificationWithIcon('success', 'Successful', `${message}`, 'bottomLeft');
                onClose();
            } catch (error) {
                if (error.response) {
                    openNotificationWithIcon('error', 'User update failed', `${error.response.data.message}`, 'bottomLeft');
                } else {
                    openNotificationWithIcon('error', 'User update failed', `${error.message}`, 'bottomLeft');
                }
            } finally {
                setShowPopconfirm(false);
                setLoading(false);
            }
        }
    }

    const handleCreateUpdateClick = async (e) => {
        e.preventDefault();
        let validation = await validateBeforeSubmit();
        if (actionState === "add" && validation) {
            handleSubmit();
        }
        else {
            if (validation) {
                setShowPopconfirm(true)
            } else {
                setShowPopconfirm(false)
            }
        }
    }

    const handleCancel = () => {
        setCancelButtonDisabled(true);
        openNotificationWithIcon('error', 'Abort', `${actionState === "add" ? "Create" : "Update"} cancelled`, 'bottomLeft');
        setTimeout(() => {
            setShowPopconfirm(false);
            setCancelButtonDisabled(false);
        }, 300);
    };

    const filterDataByCriteria = (data, criteria) => {
        return data.filter(item => {
            return criteria.every(({ key, value }) => {
                if (!item[key] || !value) return false;
                const itemValue = (item[key]?.toString() || '').toLowerCase();
                const lowerCasePrefix = (value || '').toLowerCase();
                return itemValue.includes(lowerCasePrefix);
            });
        });
    };

    // const handleSearchFunction = (value) => {
    //     setSearchInputValue(value);
    //     if (value) {
    //         if (filterValues.length > 0) {
    //             const filteredData = tempUserData.filter(item =>
    //                 item.address.toLowerCase().includes(value.toLowerCase()) ||
    //                 (item.branchName && item.branchName.toLowerCase().includes(value.toLowerCase())) ||
    //                 (item.departmentName && item.departmentName.toLowerCase().includes(value.toLowerCase())) ||
    //                 item.designation.toLowerCase().includes(value.toLowerCase()) ||
    //                 item.email.toLowerCase().includes(value.toLowerCase()) ||
    //                 item.name.toLowerCase().includes(value.toLowerCase()) ||
    //                 item.createdAt.toString().includes(value.toString()) ||
    //                 item.roleName.toLowerCase().includes(value.toLowerCase())
    //             );
    //             setTempUserData(filteredData);
    //         } else {
    //             const filteredData = userData.filter(item =>
    //                 item.address.toLowerCase().includes(value.toLowerCase()) ||
    //                 (item.branchName && item.branchName.toLowerCase().includes(value.toLowerCase())) ||
    //                 (item.departmentName && item.departmentName.toLowerCase().includes(value.toLowerCase())) ||
    //                 item.designation.toLowerCase().includes(value.toLowerCase()) ||
    //                 item.email.toLowerCase().includes(value.toLowerCase()) ||
    //                 item.name.toLowerCase().includes(value.toLowerCase()) ||
    //                 item.createdAt.toString().includes(value.toString()) ||
    //                 item.roleName.toLowerCase().includes(value.toLowerCase())
    //             );
    //             setTempUserData(filteredData);
    //         }
    //     } else {
    //         if (filterValues.length > 0) {
    //             const filterData = filterDataByCriteria(userData, filterValues);
    //             setTempUserData(filterData);
    //         } else {
    //             setTempUserData(userData)
    //         }
    //     }
    // }

    const handleSearchFunction = (value) => {
        setSearchInputValue(value);
        const searchValue = value?.toLowerCase() ?? "";

        // utility: safely check string fields
        const matches = (field) => (field ?? "").toLowerCase().includes(searchValue);

        if (value) {
            const baseData = filterValues.length > 0 ? tempUserData : userData;

            const filteredData = baseData.filter(item =>
                matches(item.address) ||
                matches(item.branchName) ||
                matches(item.departmentName) ||
                matches(item.designation) ||
                matches(item.email) ||
                matches(item.name) ||
                matches(item.roleName) ||
                (item.createdAt?.toString().includes(value.toString()))
            );

            setTempUserData(filteredData);
        } else {
            if (filterValues.length > 0) {
                const filterData = filterDataByCriteria(userData, filterValues);
                setTempUserData(filterData);
            } else {
                setTempUserData(userData);
            }
        }
    };

    const handleFilterDetailsChange = (value) => {
        setFilterValues(value);
    }

    // const handleFilterSearchFunction = (value) => {
    //     if (value) {
    //         if (searchInputValue?.length > 0) {
    //             //const searchText = searchInputValue.trim().toLowerCase();
    //             const filteredData = userData.filter(item =>
    //                 (item.branchName && item.branchName.toLowerCase().includes(searchInputValue.toLowerCase())) ||
    //                 item.email.toLowerCase().includes(searchInputValue.toLowerCase()) ||
    //                 item.name.toLowerCase().includes(searchInputValue.toLowerCase()) ||
    //                 item.roleName.toLowerCase().includes(searchInputValue.toLowerCase())
    //                 // item.createdAt.toString().includes(value.toString()) ||
    //                 // item.address.toLowerCase().includes(searchText.toLowerCase()) ||
    //                 // (item.departmentName && item.departmentName.toLowerCase().includes(searchText.toLowerCase())) ||
    //                 // item.designation.toLowerCase().includes(searchText.toLowerCase()) ||
    //             );
    //             const filterData2 = filterDataByCriteria(filteredData, value);
    //             setTempUserData(filterData2);
    //         } else {
    //             const filterData = filterDataByCriteria(userData, value);
    //             setTempUserData(filterData);
    //         }
    //     } else {
    //         if (searchInputValue?.length > 0) {
    //             const filteredData = userData.filter(item =>
    //                 item.address.toLowerCase().includes(searchInputValue.toLowerCase()) ||
    //                 (item.branchName && item.branchName.toLowerCase().includes(searchInputValue.toLowerCase())) ||
    //                 (item.departmentName && item.departmentName.toLowerCase().includes(searchInputValue.toLowerCase())) ||
    //                 item.designation.toLowerCase().includes(searchInputValue.toLowerCase()) ||
    //                 item.email.toLowerCase().includes(searchInputValue.toLowerCase()) ||
    //                 item.name.toLowerCase().includes(searchInputValue.toLowerCase()) ||
    //                 item.createdAt.toString().includes(value.toString()) ||
    //                 item.roleName.toLowerCase().includes(searchInputValue.toLowerCase())
    //             );
    //             setTempUserData(filteredData);
    //         } else {
    //             setTempUserData(userData);
    //         }
    //     }
    // }

    const handleFilterSearchFunction = (value) => {
        if (value) {
            if (searchInputValue?.length > 0) {
                const filteredData = userData.filter(item =>
                    (item.branchName?.toLowerCase().includes(searchInputValue.toLowerCase())) ||
                    (item.email?.toLowerCase().includes(searchInputValue.toLowerCase())) ||
                    (item.name?.toLowerCase().includes(searchInputValue.toLowerCase())) ||
                    (item.roleName?.toLowerCase().includes(searchInputValue.toLowerCase()))
                );
                const filterData2 = filterDataByCriteria(filteredData, value);
                setTempUserData(filterData2);
            } else {
                const filterData = filterDataByCriteria(userData, value);
                setTempUserData(filterData);
            }
        } else {
            if (searchInputValue?.length > 0) {
                const filteredData = userData.filter(item =>
                    (item.address?.toLowerCase().includes(searchInputValue.toLowerCase())) ||
                    (item.branchName?.toLowerCase().includes(searchInputValue.toLowerCase())) ||
                    (item.departmentName?.toLowerCase().includes(searchInputValue.toLowerCase())) ||
                    (item.designation?.toLowerCase().includes(searchInputValue.toLowerCase())) ||
                    (item.email?.toLowerCase().includes(searchInputValue.toLowerCase())) ||
                    (item.name?.toLowerCase().includes(searchInputValue.toLowerCase())) ||
                    (item.createdAt?.toString().includes(value?.toString())) ||
                    (item.roleName?.toLowerCase().includes(searchInputValue.toLowerCase()))
                );
                setTempUserData(filteredData);
            } else {
                setTempUserData(userData);
            }
        }
    };

    const handleRemoveTag = (key) => {
        setFilterValues(prev =>
            prev.filter(item => item.key !== key)
        );
    }

    useEffect(() => {
        handleFilterSearchFunction(filterValues);
        setCurrentPage(1); // Reset to page 1 when filters change
    }, [filterValues])

    useEffect(() => {
        handleSearchFunction(searchInputValue)
        setCurrentPage(1); // Reset to page 1 when search changes
    }, [searchInputValue])

    useEffect(() => {
        setBtnPermission({
            "add": false,
            "edit": false,
            "delete": false,
            "view": false,
            "activeInactive": false,
        })
        if (role.length > 0) {
            role.forEach(value => {
                if (value.restricted) {
                    if (value.roleName === "Company Admin") {
                        setBtnPermission({
                            "add": true,
                            "edit": true,
                            "delete": true,
                            "view": true,
                            "activeInactive": true,
                        })
                    } else if (value.roleName === "Admin") {
                        setBtnPermission({
                            "add": true,
                            "edit": true,
                            "delete": true,
                            "view": true,
                            "activeInactive": true,
                        })
                    }
                } else if (value?.permissions) {
                    const permissionData = value.permissions.find(data => data.permissionName === "User");
                    if (permissionData) {
                        permissionData.permissionLevel.map(value => {
                            switch (value) {
                                case "create":
                                    setBtnPermission(prevState => ({
                                        ...prevState,
                                        add: true
                                    }));
                                    break;
                                case "view":
                                    setBtnPermission(prevState => ({
                                        ...prevState,
                                        view: true
                                    }));
                                    break;
                                case "edit":
                                    setBtnPermission(prevState => ({
                                        ...prevState,
                                        edit: true
                                    }));
                                    break;
                                case "delete":
                                    setBtnPermission(prevState => ({
                                        ...prevState,
                                        delete: true
                                    }));
                                    break;
                                case "Active / Inactive":
                                    setBtnPermission(prevState => ({
                                        ...prevState,
                                        activeInactive: true
                                    }));
                                    break;
                            }
                        })
                    } else {
                        setBtnPermission({
                            "add": false,
                            "edit": false,
                            "delete": false,
                            "view": false,
                            "activeInactive": false,
                        })
                    }
                }
            });
        }
    }, []);

    const filterTags = filterValues.filter(filterObject => filterObject.value.trim() !== "");

    return (
        <>
            <Flex gap={20} justify='space-between' align='center' style={{
                margin: '16px',
                padding: '16px 24px',
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
            }}>
                <Breadcrumb
                    items={[
                        {
                            title: <HomeOutlined />,
                        },
                        {
                            title: 'Master Data / User',
                        },
                    ]}
                />
                <Flex justify='center' align='center' gap={12}>
                    {btnPermission.view && (
                        <>
                            <Button
                                icon={<FilterOutlined style={{ paddingLeft: 8, paddingRight: 8 }} />}
                                onClick={showFilterDrawer}
                            />
                            <Search
                                placeholder='Search'
                                value={searchInputValue}
                                onChange={(e) => setSearchInputValue(e.target.value)}
                            />
                        </>
                    )}
                    {btnPermission.add && (
                        <Button type="primary" onClick={() => {
                            const activeDepartments = roleListData.filter(value => value.label !== "Company Admin")
                            setRoleList(activeDepartments);
                            setDropDownDisable(false);
                            showDrawer();
                        }} >Add New</Button>
                    )}
                </Flex>
            </Flex>
            <div style={{ margin: '16px' }}>
                {filterTags.length !== 0 &&
                    <Flex align='center' gap={12}>
                        {filterTags.map(item => (
                            <Tag
                                bordered={false}
                                closable
                                color="success"
                                key={item?.key}
                                onClose={() => handleRemoveTag(item?.key)}
                            >
                                {item?.value}
                            </Tag>
                        ))}
                    </Flex>
                }
            </div>
            <div style={{
                margin: '16px',
                padding: 24,
                minHeight: "78svh",
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
            }}>
                {isUserListLoading ? (<>
                    <CommonSkeletonLoader />
                </>) : (<>
                    <Table
                        columns={columns}
                        dataSource={tempUserData}
                        scroll={{ x: 'max-content' }}
                        pagination={{
                            current: currentPage,
                            pageSize,
                            onChange: (page, size) => {
                                setCurrentPage(page);
                                setPageSize(size);
                            },
                            onShowSizeChange: (current, size) => {
                                setCurrentPage(1);
                                setPageSize(size);
                            },
                            showSizeChanger: true,
                            pageSizeOptions: ['10', '20', '50', '100'],
                            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                            selectProps: {
                                showSearch: false,
                                inputReadOnly: true,
                                onInputKeyDown: (e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                },
                                onKeyDown: (e) => {
                                    // Allow only arrow keys, Enter, Escape, Tab
                                    if (!['ArrowUp', 'ArrowDown', 'Enter', 'Escape', 'Tab'].includes(e.key)) {
                                        e.preventDefault();
                                    }
                                }
                            }
                        }}
                    />
                </>)}
                <Drawer
                    title={
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                            <span>{actionState === 'add' ? "Add User" : "Update User"}</span>
                            {actionState === 'add' && <Button
                                onClick={() => {
                                    navigate(`/MasterData/bulk-upload`)
                                }}>
                                Bulk Upload
                            </Button>}
                        </div>
                    }
                    onClose={onClose}
                    open={open}
                    size='large'
                    footer={[
                        <Flex justify='flex-end' align='center' gap='large'>
                            <Button onClick={onClose} disabled={loading}>
                                Cancel
                            </Button>
                            {actionState === 'add' ? (
                                <Button type="primary" onClick={handleSubmit} loading={loading}>
                                    Create
                                </Button>
                            ) : (
                                <Popconfirm
                                    title="Do you want to update the user?"
                                    open={showPopconfirm}
                                    onConfirm={() => handleSubmit()}
                                    onCancel={handleCancel}
                                    okText="Yes"
                                    cancelText="No"
                                    cancelButtonProps={{ disabled: cancelButtonDisabled }}
                                >
                                    <Button 
                                        type="primary" 
                                        onClick={handleCreateUpdateClick}
                                        disabled={!isFormModified()}
                                    >
                                        Update
                                    </Button>
                                </Popconfirm>
                            )}
                        </Flex>
                    ]}
                >
                    <Form 
                        form={form}
                        layout="vertical"
                        initialValues={{
                            name: "",
                            email: "",
                            personalNumber: "",
                            address: "",
                            roleId: null,
                            branchId: null,
                            departmentId: null,
                            designation: "",
                        }}
                    >
                        <Row gutter={12}>
                            <Col span={12}>
                                <Form.Item label="Company Name">
                                    <Input disabled placeholder={companyName} />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item 
                                    label="Name"
                                    name="name"
                                    rules={getNameRules()}
                                >
                                    <Input
                                        placeholder="Name"
                                        autoComplete="new-name"
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item 
                                    label="Email"
                                    name="email"
                                    rules={getEmailRules()}
                                >
                                    <Input
                                        disabled={actionState === "edit"}
                                        placeholder="Email"
                                        autoComplete="new-email"
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="Mobile Number"
                                    name="personalNumber"
                                    rules={getUserMobileRules()}
                                >
                                    <Input
                                        placeholder="Mobile Number"
                                        autoComplete="new-personalNumber"
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item 
                                    label="Address"
                                    name="address"
                                    rules={getAddressRules()}
                                >
                                    <Input
                                        placeholder="Address"
                                        autoComplete="new-address"
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item 
                                    label="Branch"
                                    name="branchId"
                                    rules={getBranchRules()}
                                >
                                    <Select
                                        options={branchList}
                                        placeholder="Select a Branch"
                                        allowClear={true}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item 
                                    label="Department"
                                    name="departmentId"
                                >
                                    <Select
                                        options={departmentList}
                                        placeholder="Select a Department"
                                        allowClear={true}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item 
                                    label="User Role"
                                    name="roleId"
                                    rules={getUserRoleRules()}
                                >
                                    <Select
                                        disabled={dropDownDisable}
                                        options={roleList}
                                        placeholder="Select a Role"
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item 
                                    label="Designation"
                                    name="designation"
                                    rules={getDesignationRules()}
                                >
                                    <Input
                                        placeholder="Designation"
                                        autoComplete="new-designation"
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Drawer>

                {/* View Drawer */}
                <Drawer
                    title="View User"
                    onClose={onClose2}
                    open={open2}
                // size='large'
                // footer={[
                //     <Flex justify='flex-end' align='center'>
                //         <Button onClick={onClose2}>
                //             Close
                //         </Button>
                //     </Flex>
                // ]}
                >
                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <Text type="secondary">Company Name</Text>
                            <div><Text strong>{companyName}</Text></div>
                        </Col>
                        <Col span={24}>
                            <Text type="secondary">Name</Text>
                            <div><Text strong>{viewData.name}</Text></div>
                        </Col>
                        <Col span={24}>
                            <Text type="secondary">Email</Text>
                            <div><Text strong>{viewData.email}</Text></div>
                        </Col>
                        <Col span={24}>
                            <Text type="secondary">Mobile Number</Text>
                            <div><Text strong>{viewData.personalNumber || "N/A"}</Text></div>
                        </Col>
                        <Col span={24}>
                            <Text type="secondary">Address</Text>
                            <div><Text strong>{viewData.address || "N/A"}</Text></div>
                        </Col>
                        <Col span={24}>
                            <Text type="secondary">Branch</Text>
                            <div><Text strong>{branchList.find(b => b.value === viewData.branchId)?.label || "N/A"}</Text></div>
                        </Col>
                        <Col span={24}>
                            <Text type="secondary">Department</Text>
                            <div><Text strong>{departmentList.find(d => d.value === viewData.departmentId)?.label || "N/A"}</Text></div>
                        </Col>
                        <Col span={24}>
                            <Text type="secondary">User Role</Text>
                            <div><Text strong>{roleList.find(r => r.value === viewData.roleId)?.label || "N/A"}</Text></div>
                        </Col>
                        <Col span={24}>
                            <Text type="secondary">Designation</Text>
                            <div><Text strong>{viewData.designation || "N/A"}</Text></div>
                        </Col>
                        <Col span={24}>
                            <Text type="secondary">Status</Text>
                            <div style={{ marginTop: 8 }}>
                                {viewData.status ? (
                                    <Tag color="purple" style={{ width: 90, textAlign: "center" }}>
                                        Active
                                    </Tag>
                                ) : (
                                    <Tag color="warning" style={{ width: 90, textAlign: "center" }}>
                                        Inactive
                                    </Tag>
                                )}
                            </div>
                        </Col>
                    </Row>
                </Drawer>
                <FilterComponent
                    openDrawer={openFilter}
                    closeDrawer={onCloseFilter}
                    data={tempUserData}
                    handleFilterDetailsChange={handleFilterDetailsChange}
                    filterValues={filterValues}
                    screenName="masterData_user"
                    resetFilterValues={() => setFilterValues([])}
                />
                {contextHolder}
            </div>
        </>
    )
}